import React from 'react';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { CoursesCatalog } from '../../components/CoursesCatalog/CoursesCatalog';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlHelmet } from '../../../../shared/public/SlHelmet/SlHelmet';
import { SlFooter } from '../../../../navigation/public/SlFooter/SlFooter';
import { Container, DataService } from '../../../../symphony';

export function CoursesContainer(): JSX.Element {
	useComponentWillMount(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.OnCoursesMount,
			requestType: RequestType.Parallel,
		});
	});

	const { courseCategories$: categories } = useContainerData(
		SlLEContext,
		SlDataService,
		['courseCategories$'],
	);

	const { learningExperiences$: courses } = useContainerData(
		'global',
		DataService,
		['learningExperiences$'],
	);

	return courses ? (
		<>
			<SlHelmet
				title="Learn Programming with our Online Courses | Sololearn"
				description="Discover our course catalog and start learning today. Check out our language-oriented courses (Java, Python, C++ and many more) and our career paths."
			/>
			<CoursesCatalog courses={courses} categories={categories} />
			<SlFooter />
		</>
	) : null;
}
